// extracted by mini-css-extract-plugin
module.exports = {"Progress":"Progress_Progress__3FVps","Label":"Progress_Label__2qxQc"};